import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { useEventValidateOrRefuseMutation } from "../../../features/api/apiSlice";
import { FormEventValidatePostValues } from "../../../types/events";
import { getErrorMessage } from "../../../utils/errors/errors";
import { FormEventValidateSchema } from "./FormEventValidate";

export default function useSubmitValidate({
  id: eventId,
  onSuccess,
}: {
  id: number;
  onSuccess: () => void;
}) {
  const [validateOrRefuse, { isLoading: isValidating }] =
    useEventValidateOrRefuseMutation();

  const onSubmit: SubmitHandler<FormEventValidateSchema> = useCallback(
    async (values) => {
      try {
        const formattedValues: FormEventValidatePostValues & {
          validateOrRefuse: "validate" | "refused";
        } = {
          eventId,
          validateOrRefuse: values.validateOrRefuse,
          comment: values.comment?.trim() || "",
        };
        console.log("values", values);
        console.log("Formatted Values", formattedValues);

        // 1) "Ask validation" request
        const payload = await validateOrRefuse(formattedValues).unwrap();
        console.log("Response validateOrRefuse", payload);

        // 2) Show success notification
        notification.success({
          message: `L'Ã©vÃ©nement a bien Ã©tÃ© ${formattedValues.validateOrRefuse === "validate" ? "clÃ´turÃ©" : "refusÃ©"}.`,
        });

        onSuccess();
      } catch (error) {
        console.error("Error validateOrRefuse", error);
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [eventId, onSuccess, validateOrRefuse],
  );

  return {
    onSubmit,
    isLoading: isValidating,
  };
}
